export const EGG_MARKETING_STANDARDS = [
  {
    id: 0,
    name: 'organic',
  },
  {
    id: 1,
    name: 'free-range',
  },
  {
    id: 2,
    name: 'cage-free',
  },
  {
    id: 3,
    name: 'caged',
  },
];

export const HOUSING_SYSTEMS = [
  {
    id: 0,
    name: 'aviary',
  },
  {
    id: 1,
    name: 'cages',
  },
  {
    id: 2,
    name: 'colony',
  },
  {
    id: 3,
    name: 'floor',
  },
  {
    id: 4,
    name: 'free-range',
  },
  {
    id: 5,
    name: 'furnished-cages',
  },
  {
    id: 6,
    name: 'organic',
  },
];
